<template>
  <div id="Admin">
    <AdminHeader />

    <div v-if="$route.name == 'Admin'">
      <div v-if="!$store.getters.token">
        <div class="bg-blue-900 text-center py-4 lg:px-4">
          <div class="p-2 bg-blue-800 items-center text-blue-100 leading-none lg:rounded-full flex lg:inline-flex" role="alert">
            <span class="flex rounded-full bg-blue-500 uppercase px-2 py-1 text-xs font-bold mr-3">Atenção</span>
            <span class="font-semibold mr-2 text-left flex-auto">Você não está autenticado, <router-link :to="{name: 'Login'}" class="text-blue-300">clique aqui</router-link> para se autenticar</span>
            <svg class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/></svg>
          </div>
        </div>
      </div>
      
    </div>

    <router-view/>
  </div>
</template>
<script>
import AdminHeader from "@/components/Admin/parts/Header"

export default {
  components:{
    AdminHeader
  }
  
}
</script>
